import Vue from 'vue'
import indexPageConstants from 'modules/indexPage/config/indexPageConstants'
Vue.prototype.$indexPageConstants = indexPageConstants
Vue.prototype.$allIndexPage = [
  indexPageConstants.TYPE_HOME,
  indexPageConstants.TYPE_NEWS,
  indexPageConstants.TYPE_CHILDREN,
  indexPageConstants.TYPE_PROGRAM,
  indexPageConstants.TYPE_APP,
]

Vue.prototype.$layoutTypes = [
  indexPageConstants.LAYOUT_A,
  indexPageConstants.LAYOUT_B,
  indexPageConstants.LAYOUT_C,
  indexPageConstants.LAYOUT_D,
  indexPageConstants.LAYOUT_E,
  indexPageConstants.LAYOUT_F,
  indexPageConstants.LAYOUT_G,
  indexPageConstants.LAYOUT_H,
  indexPageConstants.LAYOUT_I,
  indexPageConstants.LAYOUT_J,
  indexPageConstants.LAYOUT_K,
  indexPageConstants.LAYOUT_L,
]

Vue.prototype.$showcaseItemTypes = [
  indexPageConstants.SHOWCASE_ITEM_TYPE_PHOTO,
  indexPageConstants.SHOWCASE_ITEM_TYPE_SERIES,
  indexPageConstants.SHOWCASE_ITEM_TYPE_EP,
  indexPageConstants.SHOWCASE_ITEM_TYPE_VIDEO,
  indexPageConstants.SHOWCASE_ITEM_TYPE_NEWS,
  indexPageConstants.SHOWCASE_ITEM_TYPE_ARTICLE,
  indexPageConstants.SHOWCASE_ITEM_TYPE_POST,
]

Vue.prototype.$accentList = [
  '四縣腔', '南四縣腔', '海陸腔', '大埔腔',
  '饒平腔', '詔安腔',
]

Vue.prototype.$childrenSubTypeList = [
  indexPageConstants.SUBTYPE_CHILDREN,
  indexPageConstants.SUBTYPE_TEENS,
  indexPageConstants.SUBTYPE_ANIMATION,
]

export default {
  onAppLaunch(vm) {

  }
}
